'use client';

import { TextButton } from '@/components/common/TextButton/TextButton';
import { useI18nLabel } from '@/hooks/useI18nLabel';
import { Link } from '@/i18n/navigation';
import { useSearchParams } from 'next/navigation';
import { JobCategoryLinkFragment } from './gen/graphql/JobCategoryLink.generated';

export interface JobCategoryLinkProps {
  crewJobCategory: JobCategoryLinkFragment;
}

export function JobCategoryLink({ crewJobCategory }: JobCategoryLinkProps) {
  const searchParams = useSearchParams();
  const translate = useI18nLabel();

  return (
    <Link
      href={{
        pathname: '/jobs',
        query: {
          ...Object.fromEntries(searchParams.entries()),
          job_category: crewJobCategory.id,
        },
      }}
    >
      <TextButton size="small" fontWeight="bold">
        {translate(crewJobCategory)}
      </TextButton>
    </Link>
  );
}
